import { slugify } from '../utils/common';

const LOCALE = 'en-au';
const BASE_URL = import.meta.env.VITE_BASE_URL ? `help-center` : '';

const Category_Display_Constants = {
    category: 5,
    sections: 4,
    subSectionsLevel1: 5,
    subSectionsLevel2: 4,
    articles: 5,
};

// excludes routes for auth check
const AUTH_EXCLUDED_ROUTES = ['chat-landing'];

const queryParamUserSelection = 'userSelectedAnswer';

export {
    LOCALE,
    BASE_URL,
    Category_Display_Constants,
    AUTH_EXCLUDED_ROUTES,
    queryParamUserSelection,
};
